var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "p-20" },
    [
      _c(
        "h1",
        { staticClass: "mt-0" },
        [
          _c("svg-icon", { attrs: { "icon-class": "file-upload-solid" } }),
          _vm._v("\n\t\t" + _vm._s(_vm.$t("manualInvoiceUpload")) + "\n\t")
        ],
        1
      ),
      _vm._v(" "),
      _c("el-card", [
        _c(
          "div",
          { staticClass: "mb-20" },
          [
            _c("h3", [_vm._v("Ik wil uploaden voor:")]),
            _vm._v(" "),
            _c(
              "el-select",
              {
                attrs: { size: "mini", placeholder: _vm.$t("select") },
                model: {
                  value: _vm.selectedParticipant,
                  callback: function($$v) {
                    _vm.selectedParticipant = $$v
                  },
                  expression: "selectedParticipant"
                }
              },
              _vm._l(_vm.availableParticipants, function(item) {
                return _c("el-option", {
                  key: item.reference,
                  attrs: { label: item.name, value: item.reference }
                })
              }),
              1
            ),
            _vm._v(" "),
            _c(
              "el-select",
              {
                attrs: { size: "mini", placeholder: _vm.$t("select") },
                model: {
                  value: _vm.selectedLegalEntity,
                  callback: function($$v) {
                    _vm.selectedLegalEntity = $$v
                  },
                  expression: "selectedLegalEntity"
                }
              },
              _vm._l(_vm.availableLegalEntities, function(item) {
                return _c("el-option", {
                  key: item.reference,
                  attrs: {
                    label: item.registration_name,
                    value: item.reference
                  }
                })
              }),
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c("div", [
          _vm.currentParticipant !== null
            ? _c("div", { staticClass: "container mb-20" }, [
                _c("input", {
                  ref: "file",
                  attrs: {
                    id: "file",
                    accept: "application/zip",
                    type: "file",
                    name: "file"
                  },
                  on: { change: _vm.handleFileChange }
                })
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.onUpload } },
                [
                  _vm._v(
                    "\n\t\t\t\t\t" + _vm._s(_vm.$t("upload")) + "\n\t\t\t\t"
                  )
                ]
              )
            ],
            1
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }